export default __webpack_public_path__ + "static/N0292-040f11dcea6a2f5c9eff5816b4df6b35.png";